import { container } from "tsyringe";
import classes from "./classes.module.scss";
import { useEffect, useState } from "react";
import { useProjectId } from "hooks/useProjectId";
import ProjectTeamRoleContributorsResponseResource from "common/resources/Project/Config/Team/Role/ProjectTeamRoleContributorsResponseResource";
import RoleService from "services/projects/RoleService";
import { ProjectTeamProvider, useProjectTeamContext } from "components/pages/ProfessionalSpace/contexts/ProjectTeam";
import Roles from "components/pages/ProfessionalSpace/tabs/Team/Roles";

const roleService = container.resolve(RoleService);

type IProps = {};

function TeamContent(_props: IProps) {
	const { roles } = useRoles();

	return (
		<div className={classes["root"]}>
			<Roles roles={roles} />
		</div>
	);
}

export default function Team() {
	return (
		<ProjectTeamProvider>
			<TeamContent />
		</ProjectTeamProvider>
	);
}

const useRoles = () => {
	const { projectId } = useProjectId();
	const { projectTeamId } = useProjectTeamContext();
	const [roles, setRoles] = useState<ProjectTeamRoleContributorsResponseResource[]>([]);

	useEffect(() => {
		roleService.getAllByProjectTeamId(projectId, projectTeamId).then(setRoles);
	}, [projectId, projectTeamId]);

	return { roles };
};
